__turbopack_context__.v({
  "dialogActions": "StopBeingFanButton-module-scss-module__Uwukwa__dialogActions",
  "dialogBody": "StopBeingFanButton-module-scss-module__Uwukwa__dialogBody",
  "dialogText": "StopBeingFanButton-module-scss-module__Uwukwa__dialogText",
  "dialogTitle": "StopBeingFanButton-module-scss-module__Uwukwa__dialogTitle",
  "heartIcon": "StopBeingFanButton-module-scss-module__Uwukwa__heartIcon",
  "trigger": "StopBeingFanButton-module-scss-module__Uwukwa__trigger",
});
